import React, {useState} from 'react';
import Picker from "@emoji-mart/react";
import {emojisTranslations} from "../../services/Helpers";
import data from "@emoji-mart/data";
import CustomButtonV2 from "./CustomButtonV2";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Colors} from "../../styles/Colors";
import {regular} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Popover} from "antd";

const EmojiPicker = (props) => {
    const { onEmojiClick } = props;
    const [isEmojiOpen, setIsEmojiOpen] = useState(false);

    return (
        <Popover trigger="click" onOpenChange={open => setIsEmojiOpen(open)} overlayInnerStyle={{padding: 0}} content={
            <Picker i18n={emojisTranslations()} data={data} onEmojiSelect={onEmojiClick} emojiButtonSize={32}/>
        } title="">
            <svg style={{width: 0, height: 0, position: 'absolute'}}>
                <linearGradient x1="0%" x2="0%" y1="0%" y2="100%" id="yellowish-gradient">
                    <stop offset="50%" stopColor="#FFD00D"/>
                    <stop offset="100%" stopColor="#FFAC33"/>
                </linearGradient>
            </svg>
            <CustomButtonV2 override={({isHovered}) => <FontAwesomeIcon className={isEmojiOpen ? 'yellowish-gradient' : ''} style={{ color: isEmojiOpen ? 'url(#yellowish-gradient)' :(isHovered ? Colors.newDesign.mainText : Colors.newDesign.darkGrey) }} icon={regular('face-smile-wink')}/>}/>
        </Popover>
    );
};

export default EmojiPicker;